import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 512 512",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "card-layout-filled", -1),
    _createElementVNode("g", {
      id: "template_svg__Page-1",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", {
        id: "template_svg__icon",
        fill: "#000000",
        transform: "translate(42.667 85.333)"
      }, [
        _createElementVNode("path", {
          d: "M128 0v149.333H0V0h128Zm298.667 192v149.333h-128V192h128Zm0-192v149.333h-256V0h256ZM256 192v149.333H0V192h256Z",
          id: "template_svg__Combined-Shape"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }